import { render, staticRenderFns } from "./BrokerageAgent.vue?vue&type=template&id=9b0b6d6e&"
import script from "./BrokerageAgent.vue?vue&type=script&lang=js&"
export * from "./BrokerageAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports